export const LANG_MAP = {
  "es-cl": "es",
  "en-us": "en",
}

export function getLangFromPageContext(pageContext) {
  const pageLang = pageContext?.lang || "es-cl"
  return LANG_MAP[pageLang] || "es"
}

export function getUrlPrefix(lang) {
  return lang && lang !== "es" ? `/${lang}` : ""
}

export function getLangFromPathname(pathname = "/") {
  if (pathname === "/en" || pathname.startsWith("/en/")) {
    return "en"
  }
  return "es"
}

export function pathWithoutLangPrefix(pathname = "/") {
  if (pathname === "/en") {
    return "/"
  }
  if (pathname.startsWith("/en/")) {
    return pathname.slice(3) || "/"
  }
  return pathname || "/"
}

export function localizedPath(pathname, targetLang) {
  const basePath = pathWithoutLangPrefix(pathname)

  if (targetLang === "en") {
    return basePath === "/" ? "/en" : `/en${basePath}`
  }

  return basePath
}

export function resolveSiteLang(pathname, pageContext) {
  if (pathname) {
    return getLangFromPathname(pathname)
  }
  return getLangFromPageContext(pageContext)
}
